<template>
    <div class="row mt-5">
        <div class="offset-md-3 col-md-6">
            <form @submit.prevent="recover()" class="bg-white p-4 shadow-sm rounded-lg">

                <Alerts :_success="success" :_error="error"></Alerts>

                <h4 class="font-weight-bold mb-3">Recover Password</h4>
                <p class="text-muted">We will send a password reset
                    {{ channel == 'email' ? 'link' : 'password' }} to your {{ channel }}
                </p>

                <div class="form-group mb-3">
                    <label class="font-weight-bold">Registered E-Mail</label>
                    <input id="email" type="email" class="form-control" name="email" required
                           autocomplete="email" ref="email"
                           v-model="email" autofocus placeholder="Enter Your registered E-Mail"
                           :disabled="!channel || wait">
                </div>

                <div class="mb-3">
                    <div class="custom-control custom-switch">
                        <input type="radio" class="custom-control-input" v-model="channel" value="email"
                               id="channel-email" :disabled="wait || !email">
                        <label class="custom-control-label" for="channel-email">
                            Send reset link to my E-Mail &nbsp;
                            <a v-if="email" href="https://mail.google.com/" target="_blank">({{ email }})</a>
                        </label>
                    </div>

                    <div class="custom-control custom-switch">
                        <input type="radio" class="custom-control-input" v-model="channel" value="flock"
                               id="channel-flock" :disabled="wait || !email">
                        <label class="custom-control-label" for="channel-flock">
                            Send password to my flock channel &nbsp;
                            <a href="https://web.flock.com" target="_blank">(Go to flock)</a>
                        </label>
                    </div>
                </div>

                <div class="form-group mb-3">
                    <vue-recaptcha
                        ref="recaptcha"
                        @verify="onVerified"
                        @expired="onExpired"
                        :sitekey="sitekey">
                    </vue-recaptcha>
                </div>

                <div class="form-group mb-3">
                    <button type="submit" class="btn btn-dark mr-2" :disabled="!channel || !email || wait || !recaptcha_token">
                        <template v-if="wait">Please wait...</template>
                        <template v-else>Submit</template>
                    </button>
                    <router-link to="/login" class="btn btn-outline-dark">Go to login</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import { VueRecaptcha } from 'vue-recaptcha';

export default {
    name: "Recover",
    components: {Alerts, VueRecaptcha},
    data() {
        return {
            channel: 'flock',
            email: '',
            recaptcha_token: '',

            sitekey: process.env.VUE_APP_SITE_KEY
        }
    },
    mounted() {
        this.$refs.email.focus();
    },
    methods: {
        onExpired: function () {
            this.resetRecaptcha()
        },
        onVerified: function (token) {
            this.recaptcha_token = token
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset();
            this.recaptcha_token = ''
        },
        recover() {
            this.setLoading()
            this.clear()
            this.success = "Please wait..."
            this.$http.post('/password/reset', {email: this.email, channel: this.channel, recaptcha_token: this.recaptcha_token}).then(res => {
                this.success = res.data.data
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        }
    }
}
</script>

<style scoped>

</style>